import { render, staticRenderFns } from "./RegistrationDataInfo.vue?vue&type=template&id=6f69bd8f&scoped=true&"
import script from "./RegistrationDataInfo.vue?vue&type=script&lang=js&"
export * from "./RegistrationDataInfo.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationDataInfo.vue?vue&type=style&index=0&id=6f69bd8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f69bd8f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f69bd8f')) {
      api.createRecord('6f69bd8f', component.options)
    } else {
      api.reload('6f69bd8f', component.options)
    }
    module.hot.accept("./RegistrationDataInfo.vue?vue&type=template&id=6f69bd8f&scoped=true&", function () {
      api.rerender('6f69bd8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/customers/RegistrationDataInfo.vue"
export default component.exports